var React = require('react');

function IconCaretUp24x24 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 17.0003L12 7.00034L22 17.0003","stroke":"#142B6F","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

IconCaretUp24x24.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconCaretUp24x24;

IconCaretUp24x24.default = IconCaretUp24x24;
